module.exports = __webpack_public_path__ + "img/shippopexpress_charge_logo.a954c89a.png";